












































































































































































































































































































































































import { Component, Prop } from 'vue-property-decorator';
import { NotificationEventBus } from '@/EventBus';
import TableScoreInput from '@/views/ChoiceViewpointsScorer/ChoiceViewpointsScorerFixedTable.vue';
import FactorGroupScoringDefinition from '@/components/scoring-definition/FactorGroupScoringDefinition.vue';
import FactorValueDisplay from '@/components/common/FactorValueDisplay.vue';
import { getModule } from 'vuex-module-decorators';
import Viewpoints from '@/store/modules/Viewpoints';
import Scoring from '@/store/modules/Scoring';
import Choices from '@/store/modules/Choices';
import WorkspaceOptions from '@/store/modules/WorkspaceOptions';
import ViewpointFactorScore from '@/components/scoring-input/ViewpointFactorScore.vue';
import ScoringKeyEditorDialog from '@/components/scoring-key/ScoringKeyEditorDialog.vue';
import ChoiceFactorInput from '@/components/choice-input/ChoiceFactorInput.vue';
import ChoiceFactorInputMenu from '@/components/choice-input/ChoiceFactorInputMenu.vue';
import CommentBadge from '@/components/comments/CommentBadge.vue';
import Decisions from '@/store/modules/Decisions';
import ElementSelect from '@/components/mixins/ElementSelect';
import { mixins } from 'vue-class-component';
import Dialogs from '@/store/modules/Dialogs';
import ScoringKeyButtonTrigger from '@/components/scoring-key/ScoringKeyButtonTrigger.vue';
import TableSingleScoreInput from '@/views/ChoiceViewpointsScorer/ChoiceViewpointsScorerGrowingTable.vue';
import Modelling from '@/store/modules/Modelling';
import { Viewpoint } from '@/api/model/Viewpoint';
import ViewpointScoreChart from '@/views/ChoiceViewpointsScorer/ViewpointScoreChart.vue';
import ViewpointFactorClassChart from '@/views/ChoiceViewpointsScorer/ViewpointFactorClassChart.vue';
import ViewpointSummaryChart from '@/views/ChoiceViewpointsScorer/ViewpointSummaryChart.vue';
import Users from '@/store/modules/Users';

const decisionsModule = getModule(Decisions);
const viewpointsModule = getModule(Viewpoints);
const modellingModule = getModule(Modelling);
const scoringModule = getModule(Scoring);
const choicesModule = getModule(Choices);
const workspaceOptionsModule = getModule(WorkspaceOptions);
const userModule = getModule(Users)
@Component({
    name: 'ChoiceEvaluatorGroupComp',
    components: {
        TableSingleScoreInput,
        ButtonScoringKeyTrigger: ScoringKeyButtonTrigger,
        CommentBadge,
        MenuFactorValueEditor: ChoiceFactorInputMenu,
        FactorValueInput: ChoiceFactorInput,
        ScoringKeyEditorDialog,
        ViewpointFactorScore,
        FactorValueDisplay,
        FactorGroupScoringDefinition,
        TableScoreInput,
        ViewpointScoreChart,
        ViewpointFactorClassChart,
        ViewpointSummaryChart,
    },
})
export default class ChoiceScorerGroup extends mixins(ElementSelect) {
    @Prop({ default: 0, type: Number })
    factorLevel!: number;

    @Prop()
    elements: string[];

    @Prop({ default: () => true, type: Boolean })
    groupSummary: boolean;

    @Prop({ default: false, type: Boolean })
    displayPercentValue!: boolean;

    @Prop({ default: false, type: Boolean })
    embed: boolean;

    @Prop()
    sortedViewpoints: Viewpoint[];

    get columnWidths() {
        if (Object.keys(workspaceOptionsModule.viewpointsColumnWidth).length === 0) {
            workspaceOptionsModule.changeViewpointColumnWidth(150);
        }
        return workspaceOptionsModule.viewpointsColumnWidth;
    }

    get columnWidth() {
        return workspaceOptionsModule.viewpointColumnWidth;
    }

    get viewpointFirstCol() {
        return workspaceOptionsModule.viewpointFirstCol;
    }

    get currentUserId() {
        if(userModule.currentUserProfile){
            return userModule.currentUserProfile.userId;
        }else{
            return null;
        }
    }

    get currentUserPermission() {
        // console.log(decisionsModule.selectedDecisionUsers[this.currentUserId].permissionAccess)
        if(decisionsModule.selectedDecisionUsers && this.currentUserId){
            return decisionsModule.selectedDecisionUsers[this.currentUserId].permissionAccess
        }else{
            return null;
        }
    }

    // description
    get descriptionVisibility() {
        return workspaceOptionsModule.descriptionVisibility;
    }

    get scoreBarVisibility() {
        return workspaceOptionsModule.scoreBarVisibility;
    }

    get selectedDecision() {
        return decisionsModule.selectedDecision;
    }

    get selectionPath() {
        return workspaceOptionsModule.selectionPath;
    }

    get selectedBreadcrumb() {
        return workspaceOptionsModule.selectedPathItemId
    }

    get selectedViewpoints() {
        return viewpointsModule.selectedViewpoints;
    }

    get expansionValues() {
        return workspaceOptionsModule.expansions;
    }

    get factorResources() {
        return modellingModule.publishedModelFactorResources;
    }

    get selectedChoice() {
        return choicesModule.selectedChoice;
    }

    get scoredChoices() {
        return scoringModule.viewpointScores;
    }

    get contributingFactorResources() {
        return viewpointsModule.contributingFactorResources;
    }

    get contributingVisibility() {
        return workspaceOptionsModule.contributingFactorVisibility;
    }

    get factorListTree() {
        return modellingModule.factorListTree;
    }

    get isFactorListActive() {
        return workspaceOptionsModule.activeFactorLists.length > 0;
    }

    get showNonListFactors() {
        return workspaceOptionsModule.showNonListFactors;
    }

    get showFactorData() {
        return workspaceOptionsModule.showFactorData;
    }

    private showDataToolTip(value: any) {
        if (value && !this.showFactorData) {
            return true;
        }
        return false;
    }

    private disableFixedTable( resourceId: string ) {
        return this.factorResources[resourceId].groupTypeDefinition && this.factorResources[resourceId].groupTypeDefinition.type === 'TABLE_FIXED' && !this.showFactorData;
    }
    
    private startingFactors(resourceId: string) {
        if (workspaceOptionsModule.trimTopGroups) {
            let topFactor = resourceId;
            return this.getTopGroup(resourceId);
        } else {
            return this.factorResources[resourceId].childrenIds;
        }
    }

    private getTopGroup(topId: string) {
        if (
            this.factorResources[topId].childrenIds.length != 1
                ? true
                : 'groupTypeDefinition' in this.factorResources[this.factorResources[topId].childrenIds[0]] || this.factorResources[this.factorResources[topId].childrenIds[0]].type != 'FACTOR_GROUP'
        ) {
            return this.factorResources[topId].childrenIds;
        }

        if (this.factorResources[topId].childrenIds.length === 1) {
            return this.getTopGroup(this.factorResources[topId].childrenIds[0]);
        }
    }

    private isFactorVisible(resourceId: string) {
        if (this.showNonListFactors || !this.isFactorListActive) {
            // return  this.contributingVisibility || (!this.contributingVisibility && this.contributingFactorResources[resourceId])
            return true;
        } else {
            if (
                this.isFactorListActive &&
                this.factorListTree[resourceId] &&
                !this.showNonListFactors
            ) {
                return true;
            } else return false;
        }
    }

    // description
    private getDescriptionVisibility() {
        return this.descriptionVisibility;
    }

    private selectBreadcrumbItem(id: string) {
        workspaceOptionsModule.selectBreadcrumbItem(id);
    }

    private async updateChoiceData(value: any, resourceId: string, dataField: string) {
        if (this.selectedChoice[dataField] === value) return;

        NotificationEventBus.emitProcessingMessage();
        try {
            await getModule(Choices).updateChoiceField({
                choiceId: this.selectedChoice.id,
                value: value,
                factorResourceId: resourceId,
                refreshScoring: false,
            });
            NotificationEventBus.emitSuccessMessage();
            scoringModule.refreshScoring();
        } catch (e) {
            NotificationEventBus.emitFailedMessage(e);
        }
    }

    private factorGroupScoringDefinitionChange(factorGroup: any, scoringDefinition: any) {
        // factorGroup.summaryScoringFunction = scoringDefinition.summaryScoringFunction
        // NotificationEventBus.emitProcessingMessage();
        // viewpointsModule.updateDraftFactorGroup({
        //         viewpointId: this.selectedViewpoint.viewpointId,
        //         factorGroup: factorGroup
        //     })
        //     .then(result => NotificationEventBus.emitSuccessMessage())
        //     .catch(err => NotificationEventBus.emitFailedMessage(err));
    }

    private selectScoringDefinitionEdit(viewpointId: string, factorId: string) {
        getModule(Dialogs).editScoringDefinition({
            viewpointId: viewpointId,
            resourceId: factorId,
        });
    }

    get editPermissions() {
        return getModule(Choices).checkChoiceEditPermissions
    }

    get editContent() {
        return workspaceOptionsModule.editContent;
    }

    get editComments() {
        return workspaceOptionsModule.editComments;
    }
}
